<template>
  <v-sheet>
    <v-card
        outlined
        tile
        :loading="part.isStartedButNotDone"
    >
      <v-card-title style="word-break: break-word">{{ part.name }}</v-card-title>
      <v-card-subtitle v-if="part.isDoneSuccess" class="pb-0">
        Absolviert am {{ part.courseRunPartDetails.successDate | moment("DD.MM.YYYY HH:mm") }}
      </v-card-subtitle>
      <v-card-subtitle v-else-if="part.isDoneError" class="pb-0">
        Durchgefallen am {{ part.courseRunPartDetails.failureDate | moment("DD.MM.YYYY HH:mm") }}
      </v-card-subtitle>
      <v-card-subtitle v-else-if="part.courseRunPartDetails.startDate" class="pb-0">
        Gestartet am {{ part.courseRunPartDetails.startDate | moment("DD.MM.YYYY HH:mm") }}
      </v-card-subtitle>
      <v-card-actions>
        <v-btn v-if="part.waitsForApproval" color="blue" :disabled="!admin" text @click="startDownload">Wartet auf
          Bewertung
        </v-btn>
        <v-btn v-if="part.waitsForApproval && admin && showApprovalButtons"
               class="ma-2"
               outlined
               x-small
               fab
               @click="$emit('approve')"
               color="green">
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn v-if="part.waitsForApproval && admin && showApprovalButtons"
               class="ma-2"
               @click="$emit('deny')"
               outlined
               x-small
               fab
               color="red">
          <v-icon>mdi-cancel</v-icon>
        </v-btn>
        <v-btn
            v-else-if="part.canStart && !part.isDoneSuccess && !admin && !part.waitsForApproval"
            color="blue" text @click="$emit('start')">
          Kurs starten
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-sheet>
</template>

<script>

import moment from "moment";
import Course from "@/components/sites/Course.vue";
import CompoundCoursePart from "@/models/CompoundCoursePart";

export default {
  computed: {
    moment() {
      return moment
    }
  },
  components: {Course},
  name: "CoursePartOverview",
  data: () => ({
    showApprovalButtons: false
  }),
  props: {
    admin: {
      type: Boolean,
    },
    part: {
      type: CompoundCoursePart
    }
  },
  methods: {
    startDownload() {
      if (this.part.isStepTypeDeclaredGoods) {
        this.$emit("downloadDeclaredGoods")
      } else if (this.part.isStepTypeShippersDeclaration) {
        this.$emit("downloadShippers")
      }
      this.showApprovalButtons = true
    },
  }
}
</script>

<style scoped>

</style>
